import { SchoolActivityAttendee } from 'app/services/school-activity.service';
import { AppState } from '../../app-state/app-state';

export const getInstanceId = (state: AppState) => state.schoolActivityAttendees.entities[0]?.activity_instance_id;
export const getAttendeesForInstances = (instanceId: number) => (state: AppState) =>
	Object.values(state.schoolActivityAttendees.entities).filter(
		(attendee) => attendee != undefined && attendee.activity_instance_id === instanceId
	) as SchoolActivityAttendee[];

export const getAttendeeByUserId = (userId: number) => (state: AppState) =>
	Object.values(state.schoolActivityAttendees.entities).find((attendee) => attendee?.user_id === userId);
